<template>
    <transition name="fade">
        <div class="order-shipped">
            <div v-if="!is_success" class="shipped-body">
                <div class="pop-title">
                    <div class="title">订单发货</div>
                    <Icon type="md-close" @click="close" size="18" class="cursor" />
                </div>
                <div class="pop-body">
                    <div class="title">订单摘要</div>
                    <div class="order-info">
                        <div class="order-info-item">订单编号：{{order.order_no}}</div>
                        <div class="order-info-item">下单时间：{{order.create_time}}</div>
                        <div class="order-info-item">付款时间：{{order.pay_time}}</div>
                        <div class="order-info-item">支付方式：{{order.pay_type_text || '-'}}</div>
                        <div class="order-info-item">实际付款：{{order.total_price}}元(含运费0元)</div>
                    </div>
                    <div class="title">收货地址</div>
                    <div class="shipped-address">
                        <div class="address-info">
                            <div class="address-icon">收</div>
                            <div class="info-box">
                                <div class="name-phone">
                                    <div class="name">{{order.contact_person}}</div>
                                    <div class="phone">{{order.contact_mobile}}</div>
                                </div>
                                <div class="address">{{address}}</div>
                            </div>
                        </div>
                        <div class="address-btn">
                            <div class="btn" @click="onCopy">复制</div>
                            <div v-if="false" class="btn">修改</div>
                        </div>
                    </div>
                    <div class="logistics-box">
                        <div class="company-no-box">
                            <div class="box-item">
                                <div class="label">物流公司</div>
                                <div class="value">
                                    <Select placeholder="请选择物流公司" v-model="form.logistics_id">
                                        <Option v-for="(item,index) in logistics_company_list" :key="index" :value="item.id">{{item.name}}</Option>
                                    </Select>
                                </div>
                            </div>
                            <div class="box-item">
                                <div class="label">运单号</div>
                                <div class="value">
                                    <Input placeholder="请输入运单号" v-model="form.logistics_no" />
                                </div>
                            </div>
                        </div>
                        <div class="remark">
                            <div class="remark-label">发货备注</div>
                            <div class="remark-value">
                                <Input type="textarea" v-model="form.memo" placeholder="请输入发货备注" class="input-item"/>
                            </div>
                        </div>
                    </div>
                    <div class="title">商品信息</div>
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <div class="checkbox">
                                        <input type="checkbox" :checked="form.goods_ids.length === goods_list.length" @click="onCheckedAll" />全选
                                    </div>
                                </th>
                                <th>货品</th>
                                <th>数量</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in goods_list" :key="index">
                                <td>
                                    <div class="checkbox">
                                        <Checkbox :disabled="item.has_service?true:false" :value="form.goods_ids.includes(item.uuid)" @on-change="onChangeGoods($event,item)" />
                                    </div>
                                </td>
                                <td>
                                    <div class="goods-info">
                                        <img class="goods-img" :src="item.product_image|default_img"/>
                                        <div class="goods-name-spec">
                                            <div class="goods-name">{{item.product_name}}</div>
                                            <div class="spec">{{item.spec_info}}</div>
                                        </div>
                                    </div>
                                </td>
                                <td>x{{item.quantity}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pop-footer">
                    <div class="btn cancel" @click="close">取消</div>
                    <div class="btn confirm" @click="onConfirmShipped">确认发货</div>
                </div>
            </div>
            <div v-else class="shipped-success">
                <img src="@/assets/images/icon-success-green.png" alt="" class="icon" />
                <div class="success-title">自主发货成功</div>
                <div class="success-text">订单{{order.order_no}}已全部发货,物流信息已同步至买家订单</div>
                <div class="confirm-btn">
                    <div class="btn" @click="close">
                        确定
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { logisticsCompanyList, shopOrderDelivery } from '@/api/index';
export default{
    name:"OrderShipped",
    props:{
        order:{
            type:Object,
            default:()=>{}
        }
    },
    data(){
        return {
            is_success:false,
            form:{
                goods_ids:[],
                logistics_id:'',
                logistics_no:'',
                memo:''
            },
            goods_list:[],
            logistics_company_list:[]
        }
    },
    computed:{
        address(){
            const {province,city,zone,address} = this.order;
            return `${province}${city}${zone}${address}`;
        }
    },
    mounted(){
        console.log('this.order',this.order);
        const {uuid,goods} = this.order;
        if(!uuid){
            this.$layer.msg('订单ID不存在');
            this.$emit("close");
            return;
        }
        this.form.uuid = uuid;
        this.goods_list = goods;
        this.onGetLogisticsCompanyList();
    },
    methods:{
        onCheckedAll(){
            console.log('onchecked-all');
            const {goods_list,form} = this;
            const {goods_ids} = form;
            if(goods_ids.length === goods_list.length){
                // this.form.goods_ids = [];
                this.$set(this.form,'goods_ids',[]);
            }else{
                let goods_ids = goods_list.map(item=>item.uuid);
                this.$set(this.form,'goods_ids',goods_ids);
            }
            console.log('goods-ids',this.form.goods_ids);
        },
        onCopy(){
            const {address,order} = this;
            const {contact_mobile,contact_person} = order;
            let text = `姓名:${contact_person}\n手机:${contact_mobile}\n地址:${address}`;
            navigator.clipboard.writeText(text).then(()=>{
                this.$layer.msg('复制成功~');
            }).catch(e=>{
                console.log('err-cp',e);
                this.$layer.msg('复制失败~');
            });
        },
        async onGetLogisticsCompanyList(){
            try{
                const {code,msg,data} = await logisticsCompanyList();
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('logistics-company-list',data);
                this.logistics_company_list = data;
            }catch(e){
                console.log('err-logistics-company-list',e);
            }

        },
        onChangeGoods(e,item){
            console.log('event',e);
            console.log('change-item',item);
            if(e){
                this.form.goods_ids.push(item.uuid);
            }else{
                this.form.goods_ids = this.form.goods_ids.filter(id=>id !== item.uuid);
            }
        },
        async onConfirmShipped(){
            try{
                const {code,msg} = await shopOrderDelivery(this.form);
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('发货成功~');
                this.$emit('shipped',{is_refresh:true})
                this.close();
            }catch(e){
                console.log('err-shipped',e);
            }
            
        },
        close(){
            this.$emit("close");
        }
    }
}
</script>
<style lang="scss" scoped>
    .order-shipped{
        width:100%;
        height:100vh;
        background:rgba(0,0,0,.5);
        position:fixed;
        display:flex;
        align-items:center;
        justify-content:center;
        z-index:110;
        top:0;
        left:0;
        .shipped-body{
            width:920px;
            height:820px;
            background:#fff;
            border-radius:10px;
            display:flex;
            flex-direction:column;
            .pop-title{
                width:100%;
                display:flex;
                align-items:center;
                justify-content:space-between;
                border-bottom:1px solid #e0e0e0;
                padding:17px 16px 14px 24px;
                .title{
                    font-size:18px;
                    color:#0f1115;
                    font-weight:bold;
                }
            }
            .pop-body{
                width:100%;
                padding:20px 24px;
                display:flex;
                flex-direction:column;
                flex:1;
                overflow-y:auto;
                // padding-bottom:80px;
                .order-info{
                    display:flex;
                    flex-wrap:wrap;
                    column-gap:40px;
                    row-gap:10px;
                    margin-top:14px;
                    margin-bottom:20px;
                    .order-info-item{
                        color:#666;
                        font-size:14px;
                    }
                }
                .shipped-address{
                    width:100%;
                    background:#f6f7f9;
                    border-radius:4px;
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    padding:12px 20px 12px 10px;
                    margin-top:12px;
                    .address-info{
                        flex:1;
                        height:100%;
                        display:flex;
                        align-items:center;
                        column-gap:12px;
                        .address-icon{
                            color:#fff;
                            background:#ff5967;
                            border-radius:4px;
                            font-size:12px;
                            padding:2px 4px;
                            flex-shrink:0;
                        }
                        .info-box{
                            flex:1;
                            flex-shrink:0;
                            display:flex;
                            flex-direction:column;
                            .name-phone{
                                display:flex;
                                column-gap:24px;
                                width:100%;
                                .name,.phone{
                                    color:#333;
                                    font-size:14px;
                                }
                            }
                            .address{
                                width:100%;
                                color:#666;
                                font-size:12px;
                            }
                        }
                    }
                    .address-btn{
                        display:flex;
                        flex-direction:column;
                        row-gap:6px;
                        .btn{
                            color:#0066ff;
                            font-size:12px;
                            cursor:pointer;
                        }
                    }
                }
                .logistics-box{
                    width:100%;
                    margin-top:13px;
                    background:#f6f7f9;
                    border-radius:4px;
                    padding:20px 10px;
                    margin-bottom:20px;
                    .company-no-box{
                        width:100%;
                        display:flex;
                        align-items:center;
                        column-gap:22px;
                        .box-item{
                            display:flex;
                            align-items:center;
                            column-gap:8px;
                            flex:1;
                            flex-shrink:0;
                            .label{
                                color:#333;
                                font-size:14px;
                                flex-shrink:0;
                                &::after{
                                    content:"*";
                                    color:red;                                    
                                }
                            }
                            .value{
                                flex:1;
                            }
                        }
                    }
                    .remark{
                        display:flex;
                        column-gap:8px;
                        margin-top:20px;
                        .remark-label{
                            color:#333;
                            font-size:14px;
                            flex-shrink:0;
                        }
                        .remark-value{
                            flex:1;
                            flex-shrink:0;
                            padding-left:5px;
                        }
                    }
                }
                table{
                    width:100%;
                    margin-top:13px;
                    border-collapse:collapse;
                    table-layout:fixed;
                    thead{
                        tr{
                            border:1px solid #e3e3e3;
                            background:#f6f7f9;
                            height:32px;
                            th:first-child{
                                padding-left:12px;
                                width:80px;
                            }
                            th:nth-child(2){
                                width:60%;
                                text-align:center;
                            }
                            th{
                                text-align:center;
                            }
                        }
                    }
                    tbody{
                        tr{
                            border:1px solid #e3e3e3;
                            td{
                                text-align:center;
                                &:first-child{
                                    width:30px;
                                }
                                .goods-info{
                                    display:flex;
                                    column-gap:16px;
                                    width:100%;
                                    padding:12px 0;
                                    .goods-img{
                                        width:80px;
                                        height:80px;
                                        border-radius:4px;
                                    }
                                    .goods-name-spec{
                                        display:flex;
                                        flex-direction:column;
                                        flex:0 0 calc(100% - 96px);
                                        row-gap:12px;
                                        .goods-name{
                                            color:#333;
                                            font-size:14px;
                                            display:-webkit-box;
                                            -webkit-line-clamp:2;
                                            line-clamp:2;
                                            -webkit-box-orient:vertical;
                                            overflow:hidden;
                                            text-overflow:ellipsis;
                                            text-align:left;
                                        }
                                        .spec{
                                            color:#666;
                                            font-size:14px;
                                            text-align:left;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .pop-footer{
                width:100%;
                height:80px;
                display:flex;
                align-items:center;
                justify-content:center;
                column-gap:10px;
                border-top:1px solid #e0e0e0;
                .btn{
                    height:40px;
                    padding:0 32px;
                    line-height:40px;
                    border-radius:4px;
                    font-size:14px;
                    font-weight:bold;
                    cursor:pointer;
                    &.cancel{
                        border:1px solid #e3e3e3;
                        color:#666;
                    }
                    &.confirm{
                        background:#ff5967;
                        color:#fff;
                    }
                }
            }
        }
        .shipped-success{
            width:500px;
            height:340px;
            background:#fff;
            border-radius:10px;
            display:flex;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            .icon{
                width:64px;
                height:64px;
            }
            .success-title{
                color:#0f1115;
                font-size:24px;
                font-weight:bold;
                margin-top:22px;
            }
            .success-text{
                color:#666;
                font-size:14px;
                text-align:center;
                margin-top:14px;
            }
            .confirm-btn{
                margin-top:65px;
                width:100%;
                padding:0 40px;
                .btn{
                    width:100%;
                    height:48px;
                    cursor:pointer;
                    color:#fff;
                    font-weight:bold;
                    background:#ff5967;
                    border-radius:4px;
                    line-height:48px;
                    text-align: center;
                }
            }
        }
    }
    .title{
        color:#333;
        font-size:16px;
        font-weight:bold;
    }
    .checkbox{
        display:flex;
        align-items:center;
        justify-content:center;
        height:100%;
        width:100%;

    }
    ::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
        border-color: #ff5967;
        background-color: rgb(255, 89, 103);
    }
    ::v-deep .ivu-checkbox-focus {
        -webkit-box-shadow: 0 0 0 2px rgba(255, 89, 103, .2);
        box-shadow: 0 0 0 2px rgba(255, 89, 103, .2);
        z-index: 1;
    }
    input[type="checkbox"]{
        appearance: none;
        width: 16px;
        height: 16px;
        border: 2px solid #ddd;
        border-radius: 3px;
        background-color: #fff;
        position: relative;
        cursor: pointer;

        &:checked {
            background-color: #ff5967;  // 选中时的背景色
            border-color: #ff5967;      // 选中时的边框色
        }

        &:checked::after {
            content: '';
            position: absolute;
            left: 4px;
            top: 1px;
            width: 4px;
            height: 8px;
            border: solid white;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
        }
    }
</style>